var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-header-title"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content-header-title--image"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require(`@/assets/img/image-${_vm.image}.png`),"alt":"image planos","title":"image planos"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }